import { render, staticRenderFns } from "./SigmaReport.vue?vue&type=template&id=2841403d&scoped=true"
import script from "./SigmaReport.vue?vue&type=script&lang=js"
export * from "./SigmaReport.vue?vue&type=script&lang=js"
import style0 from "./SigmaReport.vue?vue&type=style&index=0&id=2841403d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2841403d",
  null
  
)

export default component.exports